import styled from 'styled-components';

const NavItemStyled = styled('div')`
  display: 'flex';
  padding-top: 0;
  padding-bottom: 0;
  flex-direction: column;

  .MuiButtonBase-root {
    height: 48px;
  }

  .item {
    display: block;
    padding-top: 0;
    padding-bottom: 0;
  }
  .itemLeaf {
    display: flex;
    padding-top: 0;
    padding-bottom: 0;
  }
  .MuiListItem-gutters {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .font-icon {
    width: 20px;
    height: 20px;
    /* color: ${(props) => props.theme.palette.text.secondary}; */

    > img {
      width: 24px;
      height: 24px;
    }
  }
  .button {
    color: ${(props) => props.theme.palette.text.secondary};
    padding: 12px 16px;
    justify-content: flex-start;
    text-transform: none;
    letter-spacing: 0;
    border-radius: 0;
    width: 100%;
    .title {
      font-weight: 600;
    }
    &.depth-0 {
      padding-left: 16px;
    }
    &.depth-1 {
      padding-left: 36px;
    }
    &.depth-2 {
      padding-left: 56px;
    }
    &.depth-3 {
      padding-left: 76px;
    }
    &.depth-4 {
      padding-left: 96px;
    }
  }
  .buttonLeaf {
    color: ${(props) => props.theme.palette.text.secondary};
    padding: 12px 16px;
    justify-content: flex-start;
    text-transform: none;
    letter-spacing: 0;
    width: 100%;
    border-radius: 0;
    font-weight: ${(props) => props.theme.typography.fontWeightRegular};
    .depth-0 {
      .title {
        font-weight: 600;
        /* font-weight: ${(props) =>
          props.theme.typography.fontWeightMedium}; */
      }
    }
    &.depth-0 .title {
      font-weight: 600;
    }
    &.depth-1 .title {
      font-weight: 600;
    }
    &.depth-0 {
      padding-left: 16px;
    }
    &.depth-1 {
      padding-left: 36px;
    }
    &.depth-2 {
      padding-left: 56px;
    }
    &.depth-3 {
      padding-left: 76px;
    }
    &.depth-4 {
      padding-left: 96px;
    }
    &.is-dev {
      color: #9e9e9e !important;
      .title {
        color: #9e9e9e;
      }
      &:hover {
        color: #9e9e9e !important;
        .title {
          color: #9e9e9e;
        }
      }
    }
    &.active {
      color: ${(props) => props.theme.palette.text.primary};
      background-color: ${(props) => props.theme.palette.action.active};
      :hover {
        /* color: ${(props) => props.theme.palette.text.primary}; */
        /* background-color: white !important; */
      }
    }
    &.MuiButton-root {
    }
  }
  .icon {
    display: flex;
    align-items: center;
    margin-right: ${(props) => props.theme.spacing(1)};
  }
  .title {
    margin-right: auto;
  }
  .active {
    color: ${(props) => props.theme.palette.primary.main};
    svg.icon {
      fill: ${(props) => props.theme.palette.primary.main};
    }
    :hover {
      /* background-color: ${(props) => props.theme.palette.primary.main}; */
      color: ${(props) => props.theme.palette.white};
      svg.icon {
        fill: ${(props) => props.theme.palette.white};
      }
    }
    .title {
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      /* font-weight: bolder; */
    }
    .icon {
      color: ${(props) => props.theme.palette.secondary.main};
    }
  }

  .nav-item-li {
    .buttonLeaf:hover {
      background-color: ${(props) => props.theme.palette.secondary.main};
    }
    .active:hover {
      background-color: ${(props) => props.theme.palette.primary.main};
      color: ${(props) => props.theme.palette.white};
    }
  }
`;

export { NavItemStyled };
